import IPS = require("publicsector");
import Services = require("../services");

class Service extends Services.BaseService<{ data: IPS.Parcel; href: string }> {

    static about = `Proxy for the property/parcels service`;

    constructor(public api: Services.API) {
        super(api, "property/parcels");
    }

}

export = Service; 